export { default } from './ClosingCompanyModalContent';
